import { useState } from "react";
import { Link, useRouterState } from "@tanstack/react-router";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { RouteUrl } from "@/configs/router/routes";
// import { useSelectedTeam } from "@/context/teamContext";
// import { getTeamLogo } from "@/lib/utils";
import MaterialIcon from "@/components/general/common/MaterialIcon";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/shadcn/tooltip";

const NAV_ITEMS = [
    {
        to: RouteUrl.Dashboard,
        label: "Dashboard",
        icon: "dashboard",
        prefix: RouteUrl.Dashboard,
        onboardingId: "onboarding-nav-dashboard",
    },
    {
        to: RouteUrl.Players,
        label: "Players",
        icon: "groups",
        prefix: RouteUrl.PlayerProfile,
        onboardingId: "onboarding-nav-players",
    },
    {
        to: RouteUrl.TournamentAnalysis,
        label: "Tournaments",
        icon: "emoji_events",
        prefix: RouteUrl.TournamentAnalysis,
        onboardingId: "onboarding-nav-tournaments",
    },
    {
        to: RouteUrl.Leaderboards,
        label: "Leaderboards",
        icon: "leaderboard",
        prefix: RouteUrl.Leaderboards,
        onboardingId: "onboarding-nav-leaderboards",
    },
];

const COLLAPSED_KEY = "hockeyly_sidebar_collapsed";

const NavigationSide = () => {
    const currentPath = useRouterState({ select: (select) => select.location.pathname });
    const [collapsed, setCollapsed] = useState(() => localStorage.getItem(COLLAPSED_KEY) === "true");
    // const { teamName } = useSelectedTeam();
    // const teamLogo = getTeamLogo(teamName);

    const toggle = () => {
        setCollapsed((prev) => {
            const next = !prev;
            localStorage.setItem(COLLAPSED_KEY, String(next));
            return next;
        });
    };

    const isActive = (to: string, prefix: string) => currentPath === to || currentPath.startsWith(prefix + "/");

    return (
        <aside
            className={`shrink-0 hidden lg:flex flex-col bg-surface-container-low overflow-y-auto overflow-x-hidden transition-[width] duration-200 ease-in-out ${
                collapsed ? "w-14" : "w-64"
            }`}
        >
            <div className={`py-1 mb-2 flex items-center ${collapsed ? "justify-center px-2" : "px-6"}`}>
                {/* {teamLogo ? (
                    <img
                        src={teamLogo}
                        alt={teamName}
                        className={`object-contain transition-all duration-200 ${collapsed ? "w-8 h-8" : "h-12 max-w-[140px]"}`}
                    />
                ) : (
                    !collapsed && (
                        <div>
                            <p className="text-[10px] text-on-surface-variant font-bold uppercase tracking-widest mb-1">
                                Performance
                            </p>
                            <h2 className="text-xs font-headline font-black tracking-widest text-on-surface uppercase">
                                Elite Scout Access
                            </h2>
                        </div>
                    )
                )} */}
            </div>

            <nav className="flex-1 space-y-0.5 px-2">
                {NAV_ITEMS.map((item) => {
                    const active = isActive(item.to, item.prefix);
                    const linkClass = `flex items-center gap-4 py-3 text-sm font-medium transition-colors ${
                        collapsed ? "justify-center px-0" : "px-4"
                    } ${
                        active
                            ? "bg-surface-container-highest text-primary font-bold border-r-4 border-[#ba0a06]"
                            : "text-on-surface-variant hover:bg-surface-container hover:text-on-surface"
                    }`;

                    if (collapsed) {
                        return (
                            <Tooltip key={item.to}>
                                <TooltipTrigger asChild>
                                    <Link id={item.onboardingId} to={item.to} className={linkClass}>
                                        <MaterialIcon
                                            name={item.icon}
                                            fill={active}
                                            className={`text-xl leading-none ${active ? "text-primary" : ""}`}
                                        />
                                    </Link>
                                </TooltipTrigger>
                                <TooltipContent side="right">
                                    <p>{item.label}</p>
                                </TooltipContent>
                            </Tooltip>
                        );
                    }

                    return (
                        <Link key={item.to} id={item.onboardingId} to={item.to} className={linkClass}>
                            <MaterialIcon
                                name={item.icon}
                                fill={active}
                                className={`text-xl leading-none ${active ? "text-primary" : ""}`}
                            />
                            <span className="uppercase tracking-wider text-[11px] font-bold whitespace-nowrap">
                                {item.label}
                            </span>
                        </Link>
                    );
                })}
            </nav>

            <div className={`mt-auto pb-4 ${collapsed ? "px-2" : "px-6"}`}>
                <button
                    onClick={toggle}
                    className={`w-full flex items-center py-2 text-on-surface-variant hover:text-on-surface hover:bg-surface-container rounded-md transition-colors cursor-pointer ${
                        collapsed ? "justify-center px-0" : "px-3 gap-2"
                    }`}
                >
                    {collapsed ? (
                        <ChevronRight className="h-4 w-4" />
                    ) : (
                        <>
                            <ChevronLeft className="h-4 w-4" />
                            <span className="text-[11px] font-bold uppercase tracking-wider">Collapse</span>
                        </>
                    )}
                </button>
            </div>
        </aside>
    );
};

export default NavigationSide;
